import { ReactNode } from 'react';
import { useCurrency } from '../../../../providers/ReferenceDataProvider';
import type { FormatterProps } from '../types/editor-config';
import { FormatterError } from './FormatterError';

/**
 * Formats an ISO 4217 currency code as `"CZK · Czech Koruna (Kč)"`.
 * Falls back to the raw code when the currency isn't in `ReferenceDataProvider`.
 */
export function CurrencyFormatter({ value, errors }: FormatterProps): ReactNode {
  const code = value == null || value === '' ? '' : String(value).trim().toUpperCase();
  const c = useCurrency(code);

  let text: string;
  if (!code) text = '—';
  else if (!c) text = code;
  else text = `${c.code}${c.symbol && c.symbol !== c.code ? ` (${c.symbol})` : ''}`;

  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span>{text}</span>
      <FormatterError issues={errors} />
    </span>
  );
}
